exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-1731aafc] .el-carousel__arrow{width:60px !important;height:60px !important;font-size:34px !important;color:#009f61\n}\n", "", {"version":3,"sources":["/app/src/components/AppPDFSlider.vue","/app/src/components/AppPDFSlider.vue"],"names":[],"mappings":";AAAA,sCCuFE,sBACA,uBACA,0BACA,aAAc;CACf","file":"AppPDFSlider.vue","sourcesContent":[">>>.el-carousel__arrow{width:60px !important;height:60px !important;font-size:34px !important;color:#009f61}\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n>>> .el-carousel__arrow {\n  width: 60px !important;\n  height: 60px !important;\n  font-size: 34px !important;\n  color: #009f61;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1731aafc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppPDFSlider.vue
// module id = V+JE
// module chunks = 5